import { getSession } from '@/utils/utils'

//计算比例
function calculate(small, total) {
  let smallNum = parseFloat(small), totalNum = parseFloat(total)
  if (isNaN(smallNum) || isNaN(totalNum)) {
    return 0
  }
  if (small > 0 && total === 0) {
    return 0 + '%'
  } else if (small < 0 && total === 0) {
    return 100 + '%'
  } else if (small === 0 && total === 0) {
    return 0 + '%'
  }
  return (Math.abs(Math.round(small / total * 10000)) / 100.00 + '%')
}

/**
 * 格式化时间
 * @param time
 * @returns {string}
 */
function format(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + ''
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str))
    }
  }
  return fmt
}

function formatDate(time, fmt) {
  if (!time) {
    return ''
  }
  let date = new Date(time)
  return format(date, fmt || 'yyyy-MM-dd')
  // return format(date, fmt || 'yyyy-MM-dd hh:mm:ss')
}

function formatDateD(time, fmt) {
  if (!time) {
    return ''
  }
  let date = new Date(time)
  return format(date, fmt || 'yyyy.MM.dd')
  // return format(date, fmt || 'yyyy-MM-dd hh:mm:ss')
}


//是否
function formatYESNo(val) {
  const obj = {
    YES: '是',
    NO: '否'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}


//开球方式
function kickOffMode(val) {
  const obj = {
    OSC: '連続',
    OI: 'OUT、IN同時',
    MHK: 'ショットガン'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

//确定订单的状态
function orderStatus(val) {
  const obj = {
    CONFIRM: '待确定',
    TRAVEL: '待出行',
    WAIT_PAY: '待支付',
    CANCEL: '取消',
    END: '完成',
    NOT_USED: '未使用',
    USED: '已使用',
    OVERDUE: '过期'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

//确定订单的状态
function enumAttributeStatus(val) {
  const obj = {
    ORDINARY: '普通文章',
    RELEVANT: '相关推荐',
    VIP: 'VIP',
    RACE_NEWS: '比赛文章'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

function formatBy(val) {
  const obj = {
    YES: '已审核',
    NO: '未审核'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

//男女
function formatSex(val) {
  const obj = {
    MAN: '男',
    WOMAN: '女'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

//用户状态
function userStatus(val) {
  const obj = {
    NORMAL: '正常',
    DISABLE: '禁用'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

//用户类型
function userEnumType(val) {
  const obj = {
    ADMIN: '超级管理员',
    NORMAL: '普通用户',
    BUSINESS: '商家'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

//是否置顶
function topStatus(val) {
  const obj = {
    TRUE: '是',
    FALSE: '否'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}


function padLeftZero(str) {
  return ('00' + str).substr(str.length)
}

/***
 * 解析物料属性 从缓存中加载
 * */
function formatMaterielType(val) {
  let key = 'MATERIEL_TYPE'
  var data = getSession(key)
  if (data !== null) {
    return JSON.parse(data)[val]
  } else {
    return ''
  }
}

/***
 * 解析流程分类 从缓存中加载
 * */
function formatProcessType(val) {
  let key = 'PROCESS_KEY'
  var data = getSession(key)
  if (data !== null) {
    return JSON.parse(data)[val]
  } else {
    return ''
  }
}


// 价格金额格式化
const digitsRE = /(\d{3})(?=\d)/g

// value: 传入的值; currency: 货币符号; decimals小数位数;
export function currency(value, currency, decimals) {
  value = parseFloat(value)
  if (!isFinite(value) || (!value && value !== 0)) return ''
  currency = currency != null ? currency : '￥'
  decimals = decimals != null ? decimals : 2
  let stringified = Math.abs(value).toFixed(decimals)
  let _int = decimals
    ? stringified.slice(0, -1 - decimals)
    : stringified
  let i = _int.length % 3
  let head = i > 0
    ? (_int.slice(0, i) + (_int.length > 3 ? ',' : ''))
    : ''
  let _float = decimals
    ? stringified.slice(-1 - decimals)
    : ''
  let sign = value < 0 ? '-' : ''
  return sign + currency + head +
    _int.slice(i).replace(digitsRE, '$1,') +
    _float
}

//地址标签
function addrLabel(val) {
  const obj = {
    COMPANY: '公司',
    HOME: '家',
    SCHOOL: '学校'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

//支付方式
function payment(val) {
  const obj = {
    RMB: '人民币',
    INTEGRAL: '积分'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

function SaleType(val) {
  const obj = {
    GOODS: '商品',
    COURT: '球场',
    TRAVEL: '旅行',
    SALE: 'SALE',
    RACE: '比赛'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }

}

function advertiseType(val) {
  const obj = {
    PICTURE: '图片',
    VIDEO: '视频'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }

}

//积分发放情况
function formatConfirmIntegral(val) {
  const obj = {
    YES: '已发放',
    NO: '未发放'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

//打球方式
function record(val) {
  const obj = {
    UL36: 'ダブルペリア(上限36）',
    NUL: 'ハンディ制',
    PA: 'ダブルペリア（上限なし）'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

//成绩表
function gradeTable(val) {
  const obj = {
    MAX: '大きいサイズ',
    A4: 'A4サイズ'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

//食物
function food(val) {
  const obj = {
    YES: 'コンペ料理希望',
    NO: '手配不要'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

//是否
function formatIntegralType(val) {
  const obj = {
    INCOME: '收入',
    EXPEND: '支出'
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}

//确认书
function formatConfirmation(val) {
  if (!val || val === '') {
    return '未发送'
  }
  return '已发送'
}

//确认书
function raceRaiseStatus(val) {
  const obj = {
    WAIT_APPROVAL: '待审核',
    REJECT: '审核拒绝',
    APPROVED: '审核通过',
  }
  if (val) {
    return obj[val]
  } else {
    return ''
  }
}


export {
  formatConfirmation,
  formatIntegralType,
  formatConfirmIntegral,
  advertiseType,
  SaleType,
  formatDate,
  formatYESNo,
  formatSex,
  formatMaterielType,
  formatProcessType,
  formatDateD,
  formatBy,
  calculate,
  orderStatus,
  userStatus,
  userEnumType,
  topStatus,
  addrLabel,
  payment,
  enumAttributeStatus,
  kickOffMode,
  record,
  gradeTable,
  food,
  raceRaiseStatus

}
